import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=570c1d76&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('570c1d76')) {
      api.createRecord('570c1d76', component.options)
    } else {
      api.reload('570c1d76', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=570c1d76&", function () {
      api.rerender('570c1d76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xkQrndBlEdtZ/JS/comp/openstreetmap.vue"
export default component.exports